import { Icon } from 'components'
import styles from './styles.module.scss'

const EmptyState = () => (
  <div className={styles.emptyState}>
    <Icon color="element-light" name="blocked" width={60} height={60} />
    <h2>Sem equipamentos</h2>
    <h3>Não há equipamentos instalados para esta conta</h3>
  </div>
)

export default EmptyState
